import React, { useContext } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { GatsbyImage } from "gatsby-plugin-image";
import Link from './Link';
import { LargeMonitorContext } from '../context';
import { toSnakeCase } from '../helpers/common';
import { useWindowSize } from 'rooks';

const CtaInlineImage = (props) => {
  const { module } = props;
  const { anchorTagLinkText, ctaGroup } = module;
  const { contentGroup, images } = ctaGroup;
  const { desktopImage, mobileImage } = images;
  const { innerWidth } = useWindowSize();
  const largeMonitorContext = useContext(LargeMonitorContext);
  const branding = contentGroup.branding;

  return (
    <section
      className={`cta-inline-image cta-inline-image--brand-${branding}`}
      id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
    >
      <Container className="cta-inline-image__container">
        <Grid>
          <Grid.Row>
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
            <Grid.Column
              mobile={12}
              tablet={12}
              computer={largeMonitorContext ? 10 : 12}
            >
              <div className="cta-inline-image__background">
                <Grid stackable reversed="mobile">
                  <Grid.Column
                    mobile={12}
                    tablet={7}
                    computer={7}
                    className="cta-inline-image__column cta-inline-image__column--text"
                  >
                    <div className="cta-inline-image__callout-box">
                      {contentGroup.heading && (
                        <span className="cta-inline-image__heading">
                          {contentGroup.heading}
                        </span>
                      )}
                      {contentGroup.subHeading &&
                        contentGroup.content &&
                        contentGroup.button && (
                          <div className="cta-inline-image__content-container">
                            <h3 className="cta-inline-image__sub-heading">
                              {contentGroup.subHeading}
                            </h3>
                            <p className="cta-inline-image__content">
                              {contentGroup.content}
                            </p>
                            <Link
                              to={contentGroup.button.link?.url}
                              target={contentGroup.button.link?.target}
                              className="button button--dark cta-inline-image__button no-decoration"
                            >
                              {contentGroup.button.title}
                            </Link>
                          </div>
                        )}
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    mobile={12}
                    tablet={5}
                    computer={5}
                    className="cta-inline-image__column cta-inline-image__column--image"
                  >
                    {innerWidth > 767
                      ? desktopImage &&
                        desktopImage.localFile &&
                        desktopImage.localFile.childImageSharp && (
                          <GatsbyImage
                            image={desktopImage.localFile.childImageSharp.gatsbyImageData}
                            className="cta-inline-image__img"
                            alt={desktopImage.altText || ''} />
                        )
                      : mobileImage &&
                        mobileImage.localFile &&
                        mobileImage.localFile.childImageSharp && (
                          <GatsbyImage
                            image={mobileImage.localFile.childImageSharp.gatsbyImageData}
                            className="cta-inline-image__img"
                            alt={mobileImage.altText || ''} />
                        )}
                  </Grid.Column>
                </Grid>
              </div>
            </Grid.Column>
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default CtaInlineImage;
